import React, { FC } from 'react';
import { ExpertiseComponentContainer, FormContainer } from '../../../../styles/styled';
import CreatePovsPage from '../../../CreatePovsPage';
import { PovsType } from '../../../PovsLkPage/types';

type EditPovsComponentPovs = {
  currentPovs: PovsType | null;
  id?: string;
  refresh?: () => Promise<void>;
  noAdd?: boolean;
};

export const EditPovsComponent: FC<EditPovsComponentPovs> = ({ refresh, currentPovs, id }) => {
  return (
    <ExpertiseComponentContainer>
      <FormContainer padding="20px" background={'#fff'}>
        <CreatePovsPage edit noAdd refresh={refresh} currentPovs={currentPovs} povsId={id} />
      </FormContainer>
    </ExpertiseComponentContainer>
  );
};
